module.exports = __webpack_public_path__ + "img/m-about2.15140542.png";